// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3C30-","toggleWrap":"styles_toggleWrap__1vL2u","content":"styles_content__1hZIu","selectAreaCode":"styles_selectAreaCode__1LrVM"};